const field = (item, name) => item?.[Object.keys(item || {}).find(key => key.toLowerCase() === name.toLowerCase())];
const array = value => {
    if (Array.isArray(value)) return value;
    try { const parsed = JSON.parse(value || '[]'); return Array.isArray(parsed) ? parsed : []; } catch (_) { return []; }
};
export const getRelevantFilterOptions = (products, categories, brands, sizes, tags, currency) => {
    const ids = name => new Set(products.flatMap(product => {
        const values = [field(product, name)];
        const mappings = name === 'CategoryID' ? ['ProductCategoriesJson', 'SelectedCategoriesJson'] : name === 'SizeID' ? ['ProductSizesJson'] : name === 'TagID' ? ['ProductTagsJson', 'SelectedTagsJson'] : [];
        mappings.forEach(key => array(field(product, key)).forEach(item => values.push(field(item, name))));
        return values.map(Number).filter(id => id > 0);
    }));
    const categoryIds = ids('CategoryID');
    const byId = new Map(categories.map(item => [Number(item.CategoryID), item]));
    const rootIds = new Set();
    categoryIds.forEach(id => {
        let category = byId.get(id);
        const visited = new Set();
        while (category && !visited.has(Number(category.CategoryID))) {
            visited.add(Number(category.CategoryID));
            const parent = byId.get(Number(category.ParentCategoryID));
            if (!parent) { rootIds.add(Number(category.CategoryID)); break; }
            category = parent;
        }
    });
    const related = (list, name) => { const found = ids(name); return list.filter(item => found.has(Number(field(item, name)))); };
    const prices = products.map(product => Number(field(product, 'DiscountedPrice')) > 0 ? Number(field(product, 'DiscountedPrice')) : Number(field(product, 'Price'))).filter(Number.isFinite);
    const ranges = [[0,100], [100,200], [200,300], [300,400], [400,500], [500,600], [600,1000000000]];
    return {
        categories: categories.filter(item => rootIds.has(Number(item.CategoryID))),
        brands: related(brands, 'ManufacturerID'), sizes: related(sizes, 'SizeID'), tags: related(tags, 'TagID'),
        prices: ranges.filter(([min,max]) => prices.some(price => price >= min && price <= max)).map(([min,max]) => ({id: min + '-' + max, name: max === 1000000000 ? 'Above ' + currency + min : currency + min + ' - ' + currency + max})),
        ratings: [5,4,3,2,1].filter(rating => products.some(product => Number(field(product, 'Rating')) >= rating))
    };
};
